/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { Box } from "@mui/system";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import { BiTag } from "react-icons/bi";
import { crudDe } from "../../../services/acesso";
import api from "../../../services/api";
import { Typography, Chip } from "@mui/material";
import { useEffect, useState } from "react";
import { MdInventory } from "react-icons/md";
import TextField from '@mui/material/TextField';
import Listagem from "../../../components/listagem";
import { FiHome, FiSettings } from "react-icons/fi";
import { useAppSelector } from "../../../store/hooks";
import { GridFilterOperator } from "@mui/x-data-grid";
import ModalForm from "../../../components/modal-form";
import ModalMovimentacao from "../../../components/estoque/ModalMovimentacao";
import { confirm } from "../../../components/confirm";
import { useHistory } from "react-router-dom";
import { FaMoneyBillWave, FaPlusCircle, FaMinusCircle, FaEdit, FaTrashAlt } from "react-icons/fa";
import { TipoFormulario } from "../../../services/constantes";
import { formatarParaReais, parseDecimal } from "../../../services/utilitarios";
import { LocaSmartLayout } from "../../../components/locasmart-layout";
import { AcaoGrid, ApiError, Campo, Estoque, Opcao } from "../../../services/tipos";
import { obterIdTenent, usuarioTemPermissao } from "../../../services/seguranca";
import { useFiliais } from "../../../hooks/useFiliais";

function EstoqueListagem() {
    const { empresaTemFiliais, filiaisOptions, getCampoFilial, getAcaoEmLoteFilial } = useFiliais();
    const navigate = useHistory();
    const [estoques, setEstoques] = useState<Estoque[]>([]);
    const [apenasZerados, setApenasZerados] = useState<boolean>(false);
    const [fezAlgumaAcao, setFezAlgumaAcao] = useState(false);
    const [pecasOpcoes, setPecasOpcoes] = useState<Opcao[]>([]);
    const [fornecedorOpcoes, setFornecedorOpcoes] = useState<Opcao[]>([]);
    const [categoriaOpcoes, setCategoriaOpcoes] = useState<Opcao[]>([]);
    const [identificadorOpcoes, setIdentificadorOpcoes] = useState<Opcao[]>([]);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [exibirFormModal, setExibirFormModal] = useState(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [realizarConsulta, setRealizarConsulta] = useState<boolean>(true);
    const [carregandoSelect, setCarregandoSelect] = useState<boolean>(false);
    const [modo, setModo] = useState<TipoFormulario>(TipoFormulario.tpNenhum);
    const [estoqueSelecionado, setEstoqueSelecionado] = useState<Estoque>({} as Estoque);
    const [entidadeParaAtualizarNoModal, setEntidadeParaAtualizarNoModal] = useState<any>({});
    const [forcarAtualizacaoDeEntidadeNoModal, setForcarAtualizacaoDeEntidadeNoModal] = useState<boolean>(false);
    const [modalMovTipo, setModalMovTipo] = useState<'repor' | 'debitar' | null>(null);
    const [estoqueMov, setEstoqueMov] = useState<Estoque | null>(null);

    const statusFilterOperators: GridFilterOperator[] = [
        {
            label: 'contém',
            value: 'contains',
            getApplyFilterFn: (filterItem) => {
                if (!filterItem.value) {
                    return null;
                }
                const filterValue = filterItem.value.toLowerCase();
                return ({ value }) => {
                    const pecaText = `${value.marca} - ${value.modelo} - ${value.nome}`;
                    return pecaText ? pecaText.toLowerCase().includes(filterValue) : false;
                };
            },
            InputComponent: (props) => (
                <TextField
                    fullWidth
                    variant="standard"
                    style={{ marginTop: '16px' }}
                    value={props.item.value || ''}
                    placeholder="Digite para buscar"
                    onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
                />
            ),
        },
        {
            label: 'é igual a',
            value: 'equals',
            getApplyFilterFn: (filterItem) => {
                if (!filterItem.value) {
                    return null;
                }
                const filterValue = filterItem.value.toLowerCase();
                return ({ value }) => {
                    const pecaText = value;
                    return pecaText ? pecaText.toLowerCase() === filterValue : false;
                };
            },
            InputComponent: (props) => (
                <TextField
                    variant="standard"
                    value={props.item.value || ''}
                    onChange={(event) => props.applyValue({ ...props.item, value: event.target.value })}
                    placeholder="Digite para buscar"
                    fullWidth
                    style={{ marginTop: '16px' }}
                />
            ),
        },
    ];

    const periodicidadeOpcoes: Opcao[] = [
        { valor: '4', label: 'Diário' },
        { valor: '1', label: 'Semanal' },
        { valor: '2', label: 'Quinzenal' },
        { valor: '3', label: 'Mensal' },
    ];

    const colunas = [
        {
            field: 'peca', headerName: 'Peça', flex: 1, renderCell(params: any) {
                return (<Box display="flex" flexDirection="column" py={0.5}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <FiHome size={16} />
                        <Typography variant="body2">Marca: {params.value.marca}</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                        <FiSettings size={16} />
                        <Typography variant="body2">Modelo: {params.value.modelo}</Typography>
                    </Box>

                    <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                        <BiTag size={16} />
                        <Typography variant="body2">Nome: {params.value.nome}</Typography>
                    </Box>

                </Box>);
            }, valueGetter: (params: any) => params.value,
            filterOperators: statusFilterOperators,
        },
        {
            field: 'quantidade', headerName: 'Quantidade em Estoque', flex: 0.5, type: 'number',
            renderCell(params: any) {
                const qtd = Number(params.value);
                if (qtd === 0) {
                    return (
                        <Box sx={{
                            backgroundColor: '#fee2e2', color: '#991b1b',
                            px: 1.2, py: 0.3, borderRadius: 1, fontWeight: 700, fontSize: 12,
                            display: 'inline-block',
                        }}>SEM ESTOQUE</Box>
                    );
                }
                return qtd;
            }
        },
        {
            field: 'valor', headerName: 'Valor (R$)', flex: 0.5, renderCell(params: any) {
                return formatarParaReais(params.value)
            }
        },
        {
            field: 'valorTotal', headerName: 'Total (R$)', flex: 0.5, renderCell(params: any) {
                const qtd = params.row.quantidade;
                const valorUnitario = params.row.valor;
                const total = qtd * valorUnitario;
                return formatarParaReais(total);
            }
        },
        {
            field: 'prestadorServico', headerName: 'Fornecedor', flex: 0.5, renderCell(params: any) {
                return params.value?.nome || '-';
            }
        },
        {
            field: 'identificador', headerName: 'Identificador', flex: 0.5, renderCell(params: any) {
                return params.value || '-';
            }
        },
        ...(empresaTemFiliais ? [{ field: 'idFilial', headerName: 'Unidade', flex: 1, renderCell: (params: any) => { if (!params.value) return ''; const f = filiaisOptions.find((x: any) => x.valor === params.value); return f?.label || ''; } }] : []),
    ];

    const ehCriacaoOuEdicao = modo == TipoFormulario.tpCadastro || modo == TipoFormulario.tpEdicao;

    const campoFilial = getCampoFilial({ linha: 0, coluna: 1, largura: 6 });

    const campos: Campo[] = [
        ...(campoFilial ? [campoFilial] : []),
        { label: 'Peça', nome: 'idPeca', required: true, tipo: 'select', largura: 12, coluna: 1, linha: 1, visible: true, opcoes: pecasOpcoes, carregando: carregandoSelect },
        { label: 'Quantidade', nome: 'quantidade', required: false, tipo: 'decimal', largura: 6, coluna: 1, linha: 2, visible: true, },
        { label: 'Valor Unitário', nome: 'valor', required: false, tipo: 'money', largura: 6, coluna: 2, linha: 2, visible: true, },
        { label: 'Fornecedor', nome: 'idPrestadorServico', required: false, tipo: 'select', largura: 6, coluna: 1, linha: 3, visible: true, opcoes: fornecedorOpcoes, selectBoxIsCleareable: true, apenasLeitura: modo === TipoFormulario.tpVisualizacao },
        { label: 'Identificador', nome: 'identificador', required: false, tipo: 'select', largura: 6, coluna: 2, linha: 3, visible: true, opcoes: identificadorOpcoes, selectBoxIsCleareable: true, allowNotFoundValues: true, selectBoxHint: 'Selecione ou digite para criar' },
        { label: 'Selecione esta opção para gerar o lançamento de compra das peças', nome: 'gerarLancamentoDoEstoque', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 4, visible: ehCriacaoOuEdicao, },
        { label: 'Data da Compra', nome: 'dataVencimento', required: false, tipo: 'date', largura: 6, coluna: 1, linha: 5, visible: (values: any) => ehCriacaoOuEdicao && values.gerarLancamentoDoEstoque === true },
        { label: 'Categoria Adicional', nome: 'idCategoriaAdicional', required: false, tipo: 'select', largura: 6, coluna: 2, linha: 5, visible: (values: any) => ehCriacaoOuEdicao && values.gerarLancamentoDoEstoque === true, opcoes: categoriaOpcoes, selectBoxIsCleareable: true },
        { label: 'Selecione esta opção se o pagamento for realizado a prazo', nome: 'pagoAPrazo', required: false, tipo: 'checkbox', largura: 12, coluna: 1, linha: 6, visible: (values: any) => ehCriacaoOuEdicao && values.gerarLancamentoDoEstoque === true, },
        { label: 'Parcelas', nome: 'parcelas', required: false, tipo: 'number', largura: 6, coluna: 1, linha: 7, visible: (values: any) => ehCriacaoOuEdicao && values.gerarLancamentoDoEstoque === true && values.pagoAPrazo === true },
        { label: 'Periodicidade', nome: 'periodicidade', required: false, tipo: 'select', largura: 6, coluna: 2, linha: 7, visible: (values: any) => ehCriacaoOuEdicao && values.gerarLancamentoDoEstoque === true && values.pagoAPrazo === true, opcoes: periodicidadeOpcoes },
        { label: 'Id', nome: 'id', required: false, tipo: 'text', largura: 8, coluna: 1, linha: 7, visible: false, },
    ];

    const temPermissao = usuarioTemPermissao(token, 'estoque_visualizar');

    useEffect(() => {
        if (forcarAtualizacaoDeEntidadeNoModal) {
            setForcarAtualizacaoDeEntidadeNoModal(false);
        }
    }, [forcarAtualizacaoDeEntidadeNoModal]);

    const tratarErro = (error: AxiosError<ApiError>) => {
        setCarregando(false);
        setIsSubmiting(false);
        const errorMessage = error.response?.data?.Mensagem || 'Erro desconhecido';
        toast.error(`Não foi possível continuar a operação Estoque: ${errorMessage}`);
    }

    const handleFecharModal = () => {
        setExibirFormModal(false);
        if ((modo == TipoFormulario.tpEdicao || modo == TipoFormulario.tpCadastro) && fezAlgumaAcao) {
            setRealizarConsulta(true);
            setFezAlgumaAcao(false);
        }
    }

    const handleCadastrar = () => {
        if (usuarioTemPermissao(token, 'estoque_novo')) {
            setModo(TipoFormulario.tpCadastro)
            setEstoqueSelecionado({} as Estoque);
            setEntidadeParaAtualizarNoModal({
                gerarLancamentoDoEstoque: true,
                pagoAPrazo: false,
                parcelas: 1,
                periodicidade: '3'
            });
            setForcarAtualizacaoDeEntidadeNoModal(true);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para cadastrar um novo Estoque');
        }
    }

    const handleEditar = (estoque: any) => {
        if (usuarioTemPermissao(token, 'estoque_editar')) {
            setModo(TipoFormulario.tpEdicao)
            setEstoqueSelecionado(estoque);
            setExibirFormModal(true);
        } else {
            toast.error('Você não tem permissão para editar um Estoque');
        }
    }

    const handleRepor = (estoque: Estoque) => {
        if (usuarioTemPermissao(token, 'estoque_editar')) {
            setEstoqueMov(estoque);
            setModalMovTipo('repor');
        } else {
            toast.error('Você não tem permissão para movimentar o Estoque');
        }
    };

    const handleDebitar = (estoque: Estoque) => {
        if (usuarioTemPermissao(token, 'estoque_editar')) {
            setEstoqueMov(estoque);
            setModalMovTipo('debitar');
        } else {
            toast.error('Você não tem permissão para movimentar o Estoque');
        }
    };

    const handleExclusao = async (estoque: Estoque) => {
        if (!usuarioTemPermissao(token, 'estoque_excluir')) {
            toast.error('Você não tem permissão para excluir um Estoque');
            return;
        }
        const confirmado = await confirm('Deseja realmente excluir este Estoque?');
        if (!confirmado) return;

        setCarregando(true);
        api.delete(`/estoque/${estoque.id}`)
            .then(() => {
                setTimeout(() => {
                    toast.success('Estoque foi excluído com sucesso');
                    setRealizarConsulta(true);
                }, 250);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
    };

    useEffect(() => {
        const fetchData = async () => {
            if (temPermissao && realizarConsulta) {
                setCarregando(true);
                try {
                    const response = await api.get(`/estoquePorEmpresa/${obterIdTenent(token)}`);
                    setEstoques(response.data);
                } catch (error) {
                    tratarErro(error as AxiosError<ApiError>);
                } finally {
                    setCarregando(false);
                    setRealizarConsulta(false);
                }
            }
        };
        fetchData();
    }, [temPermissao, realizarConsulta, token]);

    const requisicaoBemSucedida = (response: any) => {
        setRealizarConsulta(true);
        setExibirFormModal(false);
        setFezAlgumaAcao(true);
        setCarregando(false)
        setIsSubmiting(false)
        toast.success('Estoque salvo com sucesso')
    }

    const buscarPecas = async () => {
        setCarregandoSelect(true);
        try {
            const response = await api.get(`/PecaPorEmpresa/${obterIdTenent(token)}`);
            const novasOpcoes = response.data.map((peca: any) => ({
                codigo: peca.id,
                valor: peca.id,
                label: `${peca.marca} - ${peca.modelo} - ${peca.nome}`,
            }));
            setPecasOpcoes(novasOpcoes);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        } finally {
            setCarregandoSelect(false);
        }
    };

    const buscarFornecedores = async () => {
        try {
            const response = await api.get(`/PrestadorServicosPorEmpresa/${obterIdTenent(token)}`);
            const opcoes = response.data.map((p: any) => ({
                valor: p.id,
                label: p.nome
            }));
            setFornecedorOpcoes(opcoes);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        }
    };

    const buscarCategorias = async () => {
        try {
            const response = await api.get(`/CategoriaPorEmpresa/${obterIdTenent(token)}`);
            const opcoes = response.data.map((cat: any) => ({
                valor: cat.id,
                label: cat.nome
            }));
            setCategoriaOpcoes(opcoes);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        }
    };

    const buscarIdentificadores = async () => {
        try {
            const response = await api.get(`/EstoqueIdentificadores/${obterIdTenent(token)}`);
            const opcoes = response.data.map((identificador: string) => ({
                valor: identificador,
                label: identificador
            }));
            setIdentificadorOpcoes(opcoes);
        } catch (error) {
            tratarErro(error as AxiosError<ApiError>);
        }
    };

    const handleShowModal = () => {
        buscarPecas();
        buscarFornecedores();
        buscarCategorias();
        buscarIdentificadores();
    }

    const onSave = async (entidade: any) => {
        if (isSubmiting) return;
        setIsSubmiting(true);
        if (usuarioTemPermissao(token, 'estoque_novo') || usuarioTemPermissao(token, 'estoque_editar')) {
            const estoqueASalvar: Estoque = {
                idEmpresa: obterIdTenent(token),
                quantidade: parseDecimal(entidade['quantidade']),
                valor: parseDecimal(entidade['valor']) || 0,
                idPeca: entidade['idPeca'],
                gerarLancamentoDoEstoque: entidade['gerarLancamentoDoEstoque'] || false,
                idPrestadorServico: entidade['idPrestadorServico'] || undefined,
                parcelas: parseInt(entidade['parcelas']) || 1,
                dataVencimento: entidade['dataVencimento'] || undefined,
                periodicidade: parseInt(entidade['periodicidade']) || 3,
                idCategoriaAdicional: entidade['idCategoriaAdicional'] || undefined,
                identificador: entidade['identificador'] || undefined,
                idFilial: entidade['idFilial'] || null,
            }

            if (modo == TipoFormulario.tpEdicao) {
                estoqueASalvar['id'] = entidade['id'];
            }

            const apiAcao = modo == TipoFormulario.tpCadastro ? api.post : api.put;

            apiAcao('/estoque/', estoqueASalvar, {
                headers: {
                    'Content-Type': 'application/json',
                },
            }).then(response => {
                setTimeout(() => {
                    requisicaoBemSucedida(response);
                }, 250);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
        }
    }

    const acoesExtras: AcaoGrid[] = [
        {
            Texto: 'Repor',
            Icone: FaPlusCircle,
            Cor: '#2e7d32',
            OnClick: (entidade: any) => handleRepor(entidade),
        },
        {
            Texto: 'Debitar',
            Icone: FaMinusCircle,
            Cor: '#c62828',
            OnClick: (entidade: any) => handleDebitar(entidade),
        },
        {
            Texto: 'Editar',
            Icone: FaEdit,
            OnClick: (entidade: any) => handleEditar(entidade),
        },
        {
            Texto: 'Ver Financeiro',
            Icone: FaMoneyBillWave,
            Cor: '#2e7d32',
            OnClick: (entidade: any) => navigate.push(`/lancamento?estoque=${entidade.id}`),
        },
        {
            Texto: 'Excluir',
            Icone: FaTrashAlt,
            Cor: '#c62828',
            OnClick: (entidade: any) => handleExclusao(entidade),
        }
    ];

    const totalZerados = estoques.filter((e: any) => Number(e.quantidade) === 0).length;
    const linhasExibidas = apenasZerados ? estoques.filter((e: any) => Number(e.quantidade) === 0) : estoques;

    return (
        <>
            <LocaSmartLayout>
                <Listagem
                    permissoes={crudDe('estoque')}
                    colunas={colunas}
                    linhas={linhasExibidas}
                    nomeEntidade="Estoque"
                    headerExtra={(
                        <Chip
                            label={apenasZerados
                                ? `Mostrando ${totalZerados} sem estoque (clique para ver todos)`
                                : `Sem estoque: ${totalZerados}`}
                            color={apenasZerados ? 'error' : 'default'}
                            variant={apenasZerados ? 'filled' : 'outlined'}
                            onClick={() => setApenasZerados(v => !v)}
                            sx={{ fontWeight: 600, cursor: 'pointer' }}
                        />
                    )}
                    nomePropriedade="peca.nome"
                    carregando={carregando}
                    IconeEntidade={MdInventory}
                    exibirAcoesDeCrud={false}
                    handleCriar={handleCadastrar}
                    handleSelecionarEntidade={setEstoqueSelecionado}
                    acoesExtras={acoesExtras}
                    acoesEmLote={[
                        ...(getAcaoEmLoteFilial('Estoque', () => setRealizarConsulta(true)) ? [getAcaoEmLoteFilial('Estoque', () => setRealizarConsulta(true))!] : []),
                    ]}
                    exportOptions={[
                        { field: 'peca', headerName: 'Peça', valueGetter: ({ row }: any) => row.peca ? `${row.peca.marca} - ${row.peca.modelo} - ${row.peca.nome}` : '' },
                        { field: 'quantidade', headerName: 'Quantidade' },
                        { field: 'valor', headerName: 'Valor (R$)', valueGetter: ({ row }: any) => row.valor },
                        { field: 'valorTotal', headerName: 'Total (R$)', valueGetter: ({ row }: any) => (row.quantidade || 0) * (row.valor || 0) },
                        { field: 'prestadorServico', headerName: 'Fornecedor', valueGetter: ({ row }: any) => row.prestadorServico?.nome || '' },
                        { field: 'identificador', headerName: 'Identificador', valueGetter: ({ row }: any) => row.identificador || '' },
                    ]} />

                <ModalForm
                    urlTutorial="https://youtu.be/Lza885penGs"
                    modo={modo}
                    tamanho="lg"
                    campos={campos}
                    onSave={onSave}
                    show={exibirFormModal}
                    isSaving={isSubmiting}
                    carregando={carregando}
                    onShow={handleShowModal}
                    onHide={handleFecharModal}
                    onCancel={handleFecharModal}
                    ajudinha={
                        {
                            texto: "Atualize a quantidade de estoque de uma peça específica nesta movimentação. Embora o controle de saída geralmente seja gerenciado pelas movimentações de Manutenções, você também tem a opção de ajustar o valor do estoque diretamente aqui",
                            autoCloseTime: 3,
                            ehDestacado: true
                        }
                    }
                    entidadeSelecionada={estoqueSelecionado}
                    apiConfig={
                        {
                            endpoint: "estoque",
                            requisicaoBemSucedida: requisicaoBemSucedida,
                            tratarErro: tratarErro,
                            idTenentCampo: 'idEmpresa'
                        }
                    }
                    atualizacaoEntidade={
                        {
                            entidadeUsadaParaAtualizacao: entidadeParaAtualizarNoModal,
                            forcarAtualizacao: forcarAtualizacaoDeEntidadeNoModal
                        }
                    }
                />

                <ModalMovimentacao
                    open={modalMovTipo !== null}
                    onClose={() => { setModalMovTipo(null); setEstoqueMov(null); }}
                    onSucesso={() => { setRealizarConsulta(true); setFezAlgumaAcao(true); }}
                    tipo={modalMovTipo ?? 'repor'}
                    estoque={estoqueMov}
                />
            </LocaSmartLayout>
        </>
    );
}

export default EstoqueListagem;
